const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/team/$teamId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import type { ResourceFilterStatus } from '@/lib/api/types/teams';
import { getTeamQueryOptions } from '@/lib/queries/teams/useGetTeamQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
import { BOOLEAN_FILTER_REGEX, PICKLIST_FILTER_REGEX } from '@/lib/utils/insights/compact-filters/filterOperators';
const compactPicklistFilterSchema = z.string().regex(PICKLIST_FILTER_REGEX, 'Invalid picklist filter format. Expected: operator_value1-value2 (e.g., in_50 or in_30-34)').optional();
const compactBooleanFilterSchema = z.string().regex(BOOLEAN_FILTER_REGEX, 'Invalid boolean filter format. Expected: operator_value (e.g., is_true or is_false)').optional();
export const teamSearchSchema = z.object({
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED', 'ALL']).optional(),
  locationId: compactPicklistFilterSchema,
  showDeactivatedMembers: compactBooleanFilterSchema
}) satisfies z.ZodType<{
  resourceStatus?: ResourceFilterStatus;
  locationId?: string;
  showDeactivatedMembers?: string;
}>;
export const Route = createFileRoute('/(app)/org/$org/teams/team/$teamId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: teamSearchSchema,
  loader: async ({
    params: {
      teamId
    },
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    if (!teamId) {
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
    try {
      const teamData = await queryClient.ensureQueryData(getTeamQueryOptions({
        teamId: Number(teamId)
      }));
      const teamName = teamData?.team?.name || i18n.t('team', {
        ns: 'teams'
      });
      return {
        crumb: teamName,
        dynamicTitle: teamName
      };
    } catch (_error) {
      // Error loading team data
      return {
        crumb: i18n.t('team', {
          ns: 'teams'
        })
      };
    }
  },
  pendingComponent: FullSizeSpinner
});